import { Pipe, PipeTransform } from "@angular/core";
import {isDate, format} from "date-fns";

@Pipe({
    name: "momentTimezone",
})
export class MomentTimezonePipe implements PipeTransform {
    transform(value: any, args?: any, superscript?: boolean): any {
        if (!isDate(value)) {
            // tslint:disable-next-line: no-parameter-reassignment
            value = new Date(value);
        }

        if (isDate(value)) {
            let formatted = format(value, args);
            const found = formatted.match(/(\d)o\b/);
            if (found && found[1]) {
                formatted = formatted.replace(/\do/, this.parseOrdinal(found[1]));
            }

            if (superscript) {
                // convert 1st to 1<sup>st</st>, 2nd to 2<sup>nd</sup, etc...
                return formatted.replace(
                    /(\d+)st|(\d+)nd|(\d+)rd|(\d+)th/g,
                    // tslint:disable-next-line: radix
                    (m) =>
                        `${parseInt(m)}<sup>${m.replace(m, "")}</sup>`
                );
            }

            return formatted;
        }
    }

    parseOrdinal(int): string {
        const ones = +int % 10;
        const tens = +int % 100 - ones;

        return int + ['th', 'st', 'nd', 'rd'][ tens === 10 || ones > 3 ? 0 : ones ];
    }
}
